//Quick View

$(document).ready(function () {
  $.getScript("//cdnjs.cloudflare.com/ajax/libs/fancybox/2.1.5/jquery.fancybox.min.js").done(function() {
    quickView();
  });
});

function quickView() {
  window.leovici = window.leovici || {};
  window.leovici.products = window.leovici.products || [];

  $(".quick-view").click(function () {
    if ($('#quick-view').length == 0){$("body").append('<div id="quick-view"></div>');}
    var product_handle = $(this).data('handle');
    $('#quick-view').addClass(product_handle);
    jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
      window.leovici.products.push(product);

      var title = product.title;
      var type = product.type;
      var price = 0;
      var original_price = 0;
      var desc = product.description;
      var images = product.images;
      var variants = product.variants;
      var options = product.options;
      var tags = product.tags;
      var url = '/products/' + product_handle;
      var isPreorder = product.tags.includes('preorder');

      console.warn('Setting Title??', tags, isPreorder, title, title.replace(' - ', ' in '));

      $('.qv-product-title').html(title.replace(' - ', ' <i> in </i>'));
      $('.qv-product-type').text(type);
      $('.qv-product-description').html(desc);

      $('.qv-add-button').val(isPreorder ? 'PREORDER' : 'ADD TO CART');

      $('.view-product').attr('href', url);

      var imageCount = $(images).length;
      $(images).each(function (i, image) {
        if (i == imageCount - 1) {
          var image_embed = '<div><img src="' + image + '"></div>';
          image_embed = image_embed.replace('.jpg', '_800x.jpg').replace('.png', '_800x.png');
          $('.qv-product-images').append(image_embed);

          $('.qv-product-images').slick({
            'dots': false,
            'nextArrow': '<span class="slide-arrow arrow-next"><img src="https://cdn.shopify.com/s/files/1/1830/0563/files/right-arrow.png?v=1589802149"></span>',
      		  'prevArrow': '<span class="slide-arrow arrow-prev"><img src="https://cdn.shopify.com/s/files/1/1830/0563/files/left-arrow.png?v=1589802141"></span>',
            'respondTo': 'min',
            'useTransform': false
          }).css('opacity', '1');

        } else {
          image_embed = '<div><img src="' + image + '"></div>';
          image_embed = image_embed.replace('.jpg', '_800x.jpg').replace('.png', '_800x.png');
          $('.qv-product-images').append(image_embed);
        }
      });
      $(options).each(function (i, option) {
        var opt = option.name;
        var selectClass = '.option.' + opt.toLowerCase();
        // $('.qv-product-options').append('<div class="option-selection-' + opt.toLowerCase() + '"><span class="option">' + opt + '</span><select class="option-' + i + ' option ' + opt.toLowerCase() + '"></select></div>');
        // $(option.values).each(function (i, value) {
        //   $('.option.' + opt.toLowerCase()).append('<option value="' + value + '">' + value + '</option>');
        // });
        const options = option;
        const radioWrappers = document.createElement('div');
        radioWrappers.classList.add('radio-wrappers');
        radioWrappers.innerHTML = `
          ${option.values.map((option, index) => {
            return `
              <div class="option">
				<input class="qv-variant-option" ${options.values.length === 1 ? 'checked' : ''} data-index="${i+1}" data-source="${product.id}" id="option-qv-${index}" type="radio" name="qv-option-${opt.toLowerCase()}"  value="${option}" />
                <label for="option-qv-${index}">${option}</label>
              </div>
            `;
          }).join('')}
        `;

        if (options.values.length === 1) {
          radioWrappers.style.display = 'none';
        }
        $('.qv-product-options').append(radioWrappers);
        $('.qv-product-options input:first-child').trigger('change');
        
      });
      $(product.variants).each(function (i, v) {
        if (v.inventory_quantity == 0) {
          $('.qv-add-button').prop('disabled', true).val('Sold Out');
          $('.qv-add-to-cart').hide();
          $('.qv-product-price').text('Sold Out').show();
          return true
        } else {
          price = parseFloat(v.price / 100).toFixed(2);
          original_price = parseFloat(v.compare_at_price / 100).toFixed(2);
          $('.qv-product-price').text('$' + price);
          if (original_price > 0) {
            $('.qv-product-original-price').text('$' + original_price).show();
          } else {
            $('.qv-product-original-price').hide();
          }
          $('select.option-0').val(v.option1);
          $('select.option-1').val(v.option2);
          $('select.option-2').val(v.option3);
          return false
        }
      });
    });

    $(document).on('change', '.qv-variant-option', function(event) {
      const $input = event.target;
      const optionChosen = $input.value;
      const optionIndex = $input.getAttribute('data-index');
      const productID = $input.getAttribute('data-source');
      const product = window.leovici.products.find(function(product) { return product.id == productID });
      
      const variant = product.variants.find(function(variant) {  return variant[`option${optionIndex}`] == optionChosen });
      // console.log('Variant Option Changed', event.target, event.target.value, product, variant);
      $('.qv-add-button').attr('data-add', variant.id);
    });


    function processCart(variantID) {
      var qty = 1;
      
      const product = window.leovici.products.find(function(item) {
        const variantIDS = item.variants.map(function(variant) {
          return variant.id;
        });

        return variantIDS.includes(parseInt(variantID));
      })
      var isPreorder = product.tags.includes('preorder');
      var expectedDate = product.tags.find(function(tag) {
        return /expected ship date/i.test(tag);
      });

      var properties = {};

      if(isPreorder && expectedDate) {
        properties['Expected Ship Date'] = expectedDate.split(':')[1];
      }


      jQuery.post('/cart/add.js', {
        quantity: qty,
        id: variantID,
        properties: properties,
      },
                  null,
                  "json"
                 ).done(function () {
        $('.qv-add-to-cart-response').addClass('success').html('<span>' + $('.qv-product-title').text() + ' has been added to your cart. <a href="/cart">Click here to view your cart.</a>');
      })
      .fail(function ($xhr) {
        var data = $xhr.responseJSON;
        $('.qv-add-to-cart-response').addClass('error').html('<span><b>ERROR: </b>' + data.description);
      });
    }

    $(document).on("click", ".qv-add-button", function (event) {
      const variantID = event.target.getAttribute('data-add');

      processCart(variantID);
    });

    $.fancybox({
      href: '#quick-view',
      maxWidth: 1040,
      maxHeight: 600,
      fitToView: true,
      width: (window.innerWidth < 900) ? '99%' : '75%',
      height: (window.innerWidth < 900) ? '90%' : '70%',
      autoSize: false,
      closeClick: false,
      openEffect: 'none',
      closeEffect: 'none',
      'beforeLoad': function () {
        $('.fancybox-wrap').css('overflow', 'hidden !important');
      },
      'afterShow': function () {
        $('#quick-view').hide().html(content).css('opacity', '1').fadeIn(function () {
          $('.qv-product-images').addClass('loaded');
        });
        $('.fancybox-wrap').addClass('quick-fancy');
        console.warn('After Fancy Show');
      },
      'afterClose': function () {
        $('#quick-view').removeClass().empty();
      }
    });
  });
};

$(window).resize(function () {
  if ($('#quick-view').is(':visible')) {
    $('.qv-product-images').slick('setPosition');
  }
});